<div
  class="content-class"
  [style.filter]="blurPage == true ? 'blur(0.2rem)' : 'blur(0)'"
>
  <div class="content-block">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="tap-bloc-style">
        <abc-button
          (click)="redirectToCompanies()"
          [text]="dataService.res('Ubt-SubProject-Create-Company')"
          [disabled]="!appService.isCompanySelected()"
          class="action-button"
        ></abc-button>
        @if (appService.isCompanySelected()) {
          <i class="dx-icon-chevronright breadcrumbs-right-icon"></i>
          <abc-button
            [text]="dataService.res('Company-Select-Project')"
            [disabled]="appService.isCompanySelected()"
            class="action-button"
          ></abc-button>
        }
      </div>
    </div>
    <div
      fxFill
      fxLayout="row wrap"
      class="company-selection-container"
      fxLayoutGap.gt-md="20px"
    >
      <div
        fxLayout="column"
        fxFlex.gt-sm="calc(68% - 20px)"
        fxFlex.sm="100"
        fxFlex.xs="100"
        fxLayoutGap="20px"
        class="wrap-card-container"
      >
        <div id="searchBloc" fxLayout="column" class="filter-card">
          <div class="card-container">
            <div
              fxFill
              fxLayout="row"
              fxLayoutAlign="space-evenly stretch"
              fxLayoutGap="5px"
              fxLayout.xs="column"
            >
              <div fxLayout="column" fxFlex="60">
                <abc-text-box
                  class="search"
                  placeholder="{{ res('Company-Icon-Search') }}"
                  [mode]="'search'"
                  stylingMode="outlined"
                  labelMode="floating"
                  valueChangeEvent="keyup"
                  [(value)]="searchValue"
                  (onValueChanged)="resetSearch($event)"
                  (input)="searchTerm.next($event.target.value)"
                >
                </abc-text-box>
              </div>
              <div fxLayout="column" fxFlex="40">
                <abc-select-box
                  [visible]="!isCompanySelected()"
                  #filterField
                  class="select-box-filter"
                  [stylingMode]="'outlined'"
                  [labelMode]="'floating'"
                  displayExpr="name"
                  valueExpr="id"
                  [items]="filterOptions"
                  (onItemClick)="selectFilterOption($event)"
                >
                </abc-select-box>
              </div>
            </div>
          </div>
        </div>
        <div class="card-container" fxFlex="100" fxFlex.sm="100">
          @if (!appService.isCompanySelected()) {
            <company-card
              id="companies"
              style="display: block"
              [companies]="companies"
              [filterActive]="filterActive"
              [navigateUrl]="navigateUrl"
              [companyIdDependency]="companyIdDependency"
              [companyNameDependency]="companyNameDependency"
              [configDependencies]="configDependencies"
              (clickCompany)="clickCompanyAction($event)"
              (selectCompany)="hoverCompanyAction($event)"
            >
            </company-card>
          }

          @if (appService.isCompanySelected()) {
            <div>
              <div
                fxLayout="row"
                fxLayout.sm="column"
                fxLayoutAlign="space-between none"
                class="card-heigh"
              >
                <div fxFlex="100" fxLayout="column">
                  <div
                    content
                    gdColumns="repeat(2, 1fr)"
                    gdColumns.gt-md="repeat(2, 1fr)"
                    gdColumns.md="repeat(2, 1fr)"
                    gdColumns.sm="repeat(2, 1fr)"
                    gdColumns.xs="1fr"
                    gdRows="repeat(2, 1fr)"
                    gdRows.gt-md="repeat(2, 1fr)"
                    gdGap="8px"
                  >
                    @for (project of projects(); track project) {
                      <div
                        class="projects-card card"
                        (click)="navigateToDashboard(project)"
                      >
                        <span class="category">{{
                          project.ParentAddress
                        }}</span>
                        <h3 class="project-title">
                          {{ project.Label }}
                        </h3>

                        <div class="divider"></div>

                        <div class="stats-container">
                          <div class="stat-item">
                            <span class="stat-value">{{
                              project.subProjectsCount
                            }}</span>
                            <span class="stat-label">{{
                              dataService.res("Company-Sub-Project")
                            }}</span>
                          </div>
                          <div class="stat-item">
                            <span class="stat-value">{{
                              project.measuresCount
                            }}</span>
                            <span class="stat-label">{{
                              dataService.res("Company-Measures")
                            }}</span>
                          </div>
                          <div class="stat-item">
                            <span class="stat-value">{{
                              project.tasksCount
                            }}</span>
                            <span class="stat-label">{{
                              dataService.res("Company-Milestones")
                            }}</span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div
        class="card-container-wrapper"
        fxLayout="row"
        fxFlex="30"
        fxFlex.sm="100"
        fxFlex.xs="100"
      >
        <div class="card-container" fxFlex.xs="100" fxFlex.sm="100">
          <abc-accordion
            class="accordion-style implement-plain-container"
            [collapsible]="true"
            [selectedIndex]="1"
            [width]="'100%'"
            [animationDuration]="300"
            [visible]="true"
            [multiple]="false"
            [dataSource]="['Test']"
          >
            <div
              *dxTemplate="let implementationPlan of 'title'"
              class="dx-accordion-item-title"
            >
              {{ dataService.res("Company-My-Most-Recently-Worked-Projects") }}
            </div>
            <div *dxTemplate="let company of 'item'">
              <div class="last-project-updated">
                {{
                  dataService.res("Company-My-Most-Recently-Worked-Projects")
                }}
              </div>
              <project-card
                (selectLastProjectUpdated)="
                  selectLastProjectUpdatedAction($event)
                "
              >
              </project-card>
            </div>
          </abc-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
